/**
 * Oferta relâmpago — urgência por visitante
 *
 * - Na mesma visita (sessão): produto visto na PDP continua em oferta.
 * - Ao sair e voltar no mesmo dia (SP): produtos vistos somem só para esse visitante.
 * - Demais produtos seguem na oferta.
 * - À meia-noite (America/Sao_Paulo) a lista do dia zera e os produtos voltam.
 */
(function (window, document) {
  'use strict';

  var TIME_ZONE = 'America/Sao_Paulo';
  var STORAGE_KEY = 'maxiFlashOfferV1';
  var SESSION_KEY = 'maxiFlashSessionActive';
  var dayFormatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });

  function saoPauloDay() {
    return dayFormatter.format(new Date());
  }

  function uniqueIds(list) {
    var seen = {};
    var out = [];
    (list || []).forEach(function (raw) {
      var id = String(raw || '').trim();
      if (!id || seen[id]) return;
      seen[id] = true;
      out.push(id);
    });
    return out;
  }

  function emptyState(day) {
    return { day: day || saoPauloDay(), consumed: [], pending: [] };
  }

  function readState() {
    var today = saoPauloDay();
    var state = emptyState(today);
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return state;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return state;
      if (parsed.day !== today) return emptyState(today);
      state.consumed = uniqueIds(parsed.consumed);
      state.pending = uniqueIds(parsed.pending);
      return state;
    } catch (error) {
      return emptyState(today);
    }
  }

  function writeState(state) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
        day: state.day || saoPauloDay(),
        consumed: uniqueIds(state.consumed),
        pending: uniqueIds(state.pending)
      }));
    } catch (error) {
      // ignore quota / private mode
    }
  }

  function ensureSession() {
    try {
      if (window.sessionStorage.getItem(SESSION_KEY)) return readState();
      window.sessionStorage.setItem(SESSION_KEY, '1');
    } catch (error) {
      return readState();
    }

    var state = readState();
    if (state.pending.length) {
      state.consumed = uniqueIds(state.consumed.concat(state.pending));
      state.pending = [];
      writeState(state);
    }
    return state;
  }

  function isConsumed(productId) {
    var id = String(productId || '').trim();
    if (!id) return false;
    var state = ensureSession();
    return state.consumed.indexOf(id) !== -1;
  }

  function markViewed(productId) {
    var id = String(productId || '').trim();
    if (!id) return;
    var state = ensureSession();
    if (state.consumed.indexOf(id) !== -1) return;
    if (state.pending.indexOf(id) !== -1) return;
    state.pending.push(id);
    writeState(state);
  }

  function hideConsumedCards(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('[data-flash-product-id]');
    cards.forEach(function (card) {
      var id = card.getAttribute('data-flash-product-id');
      if (!isConsumed(id)) return;
      card.setAttribute('hidden', '');
      card.style.display = 'none';
    });
  }

  function hideConsumedPdpBlocks(root) {
    var scope = root || document;
    var blocks = scope.querySelectorAll('flash-sale[data-product-id]');
    blocks.forEach(function (block) {
      if (block.hasAttribute('data-sku-override')) return;
      var id = block.getAttribute('data-product-id');
      if (!isConsumed(id)) return;
      block.setAttribute('hidden', '');
      block.setAttribute('data-flash-consumed', 'true');
    });
  }

  function init() {
    ensureSession();
    hideConsumedCards(document);
    hideConsumedPdpBlocks(document);
  }

  window.MaxiFlashSession = {
    ensureSession: ensureSession,
    isConsumed: isConsumed,
    markViewed: markViewed,
    hideConsumedCards: hideConsumedCards,
    hideConsumedPdpBlocks: hideConsumedPdpBlocks,
    init: init
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window, document);
